import pouchImg from 'assets/pouchImg.png'

export const FirstProject = {
  id: 1,
  name: 'Pouch',
  desc: 'Coming Soon',
  longDesc: '',
  link: '',
  img: pouchImg,
  technology: ['ReactJS', 'Tailwind', 'Figma', 'DynamoDB', 'Java'],
  year: 2024,
  date:'',
  online: false,
}